import React from 'react';

import styles from './style.scss';


const ContextAuthorCardEmpty = () => (
  <div className="billetContainer">
    <div className={styles.author}>
      <div className={styles.authorBlock}>
        <div className={styles.authorImage} />
      </div>
    </div>
  </div>
);

export default ContextAuthorCardEmpty;
